import { render, staticRenderFns } from "./PainelAcessibilidade.vue?vue&type=template&id=b992e5e0"
import script from "./PainelAcessibilidade.vue?vue&type=script&lang=js"
export * from "./PainelAcessibilidade.vue?vue&type=script&lang=js"
import style0 from "./PainelAcessibilidade.vue?vue&type=style&index=0&id=b992e5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports